import { Edit, useRecordContext } from "react-admin";
import { MealForm } from "./form";

const AccEditTtitle = () => {
  const record = useRecordContext();
  return <span>Edit {record ? `"${record.name}"` : ""} </span>;
};

export const AccomodationEdit = () => (
  <Edit title={<AccEditTtitle />}>
    <MealForm source="name" />
  </Edit>
);
